import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-calculators',
  standalone: false,
  templateUrl: './home.page.html'
})
export class HomePageComponent {}
